import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface ExerciseSearchSliceState {
	// The debounced search term that triggers API queries
	query: string;
}

const initialState: ExerciseSearchSliceState = {
	query: '',
};

const exerciseSearchSlice = createSlice({
	name: 'features/exerciseSearch',
	initialState,
	reducers: {
		querySet: (state, action: PayloadAction<string>) => {
			state.query = action.payload;
		},
		queryCleared: (state) => {
			state.query = '';
		},
	},
});

const exerciseSearchSliceActions = { ...exerciseSearchSlice.actions };
const exerciseSearchSliceReducer = exerciseSearchSlice.reducer;

export { exerciseSearchSliceActions, exerciseSearchSliceReducer };
export type { ExerciseSearchSliceState };
